(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["site-nav"]) return;
  try {
    
  $(document).ready(function(){
    $(".site_nav .main_menu .main_li").hover(function(){
      $(".child_menu",this).stop().fadeIn();
    },function(){
      $(".child_menu",this).stop().fadeOut();
    });
    $(".site_nav .child_li").hover(function(){
  var parent =   $(this).closest(".child_menu");
      $(".link_data .img",parent).hide();
      $(".link_data .img ",this).show();
    });
  });
  
  } catch(e) { console.error(e); }
})();
})();
